import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useEffect, useMemo } from 'react';
import { IItemForGetShortInfo, IGetGameDevelopersShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getGameDevelopersShortInfo } from 'backend/games';
import { TCreateGameSelectedItem } from 'modules/Entertainment/Games/CreateGame/createGameState/createGameContext';
import { useTranslation } from 'react-i18next';

interface IDeveloperSelect {
	setIDDeveloper: (value: TCreateGameSelectedItem) => void;
	setFetchedDevelopers: (value: IItemForGetShortInfo[]) => void;
	refetchDevelopers: (value: boolean) => void;
	needRefetchDevelopers: boolean;
}

const DeveloperSelect: React.FC<IDeveloperSelect> = ({
	needRefetchDevelopers,
	refetchDevelopers,
	setFetchedDevelopers,
	setIDDeveloper,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetGameDevelopersShort, void>(
		getGameDevelopersShortInfo,
	);
	const { t } = useTranslation('error');

	useEffect(() => {
		if (response) {
			setFetchedDevelopers(response.data.gameDevelopers);
		}
	}, [response]);

	useEffect(() => {
		if (needRefetchDevelopers) {
			refetch();
			refetchDevelopers(false);
		}
	}, [needRefetchDevelopers]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectDeveloper') }], [t]);

	return (
		<FormSelect
			testId="DeveloperSelect"
			name="IDSelectedDeveloper"
			label="developerLabel"
			options={response?.data.gameDevelopers}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDDeveloper}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DeveloperSelect);
